export const TITLE_CHART = {
  left: "center",
  top: "9"
};

export const GRID_CHART = {
  top: "45",
  left: "5%",
  right: "5%",
  bottom: "5",
  containLabel: true
};

export const GRID_CHART_WITH_LEGEND = {
  top: "45",
  left: "5%",
  right: "30%", // deja espacio para la leyenda
  bottom: "5",
  containLabel: true
};
export const LEGEND_CHART = {
  type: "scroll",
  orient: "vertical",
  left: "70%",
  top: 45,
  bottom: 5,
  formatter: function(name: string) {
    const maxCharsPerLine = 12; // Máx. de caracteres por línea
    const words = name.split(" ");
    const lines: string[] = [];
    let currentLine = "";

    words.forEach(word => {
      if ((currentLine + word).length <= maxCharsPerLine) {
        currentLine += (currentLine ? " " : "") + word;
      } else {
        lines.push(currentLine);
        currentLine = word;
      }
    });
    if (currentLine) lines.push(currentLine);

    return lines.join("\n"); // Devuelve texto multilínea
  },
  textStyle: {
    overflow: "break",
    fontSize: 10
  },
  z: 100
};
